/** Короткий підсумок вибраного збереженого подання поруч із вибором (UIUX tables/saved-views): «Дошка · 2 фільтри». */
import type { ISavedView } from '@platform/core/types';
import { cardRulesOf } from '../../views/cards/cardRules';

/** Кількість умов фільтр-DSL визначення подання (`поле:оператор[:значення]` через `;`). Чиста функція. */
export function savedFilterCount(view: Pick<ISavedView, 'definition'>): number {
  return (view.definition.filter ?? '').split(';').filter((s) => s.trim()).length;
}

/** «Вид · N фільтрів · N правил кольору» (без фільтрів і правил — лише вид); `t` — переклад рядків панелі списку. Чиста функція. */
export function savedViewSummary(view: Pick<ISavedView, 'kind' | 'definition'>, t: (key: string, vars?: Record<string, unknown>) => string): string {
  const count = savedFilterCount(view);
  const rules = cardRulesOf(view.definition).length;
  return [t(`listbar.viewKinds.${view.kind}`), count ? t('listbar.filters', { count }) : '', rules ? t('listViews.colourRules', { count: rules }) : ''].filter(Boolean).join(' · ');
}
